<template>
  <div class="sg-goods-evaluation-list">
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="isError"
          error-text="请求失败，点击重新加载"
          finished-text="没有更多了"
          @load="getAppEssaysByCondition"
      >
        <evaluation-item v-for="(item, i) in list" :key="i" :item="item"></evaluation-item>
      </van-list>
    </van-pull-refresh>

  </div>
</template>

<script>
import { evaluatedList } from '@/api/mall/mallGoods'
import evaluationItem from '@/views/Mall/sg/components/evaluationItem';
export default {
  components: {
    evaluationItem,
  },
  data(){
    return {
      page: 1,
      size: 10,
      list: [],
      refreshLoading: false,
      loading: false,
      finished: false,
      isError: false,
    }
  },
  methods: {
    getAppEssaysByCondition(){
      let req = {
        shopId: this.$route.query.shopId,
        goodsId: this.$route.query.goodsId,
        page: this.page,
        size: this.size,
      }
      evaluatedList(req).then(res=>{
        let arr = res.data.items || []
        if(arr.length>0){
          if (this.page === 1){
            this.list = [];
          }
          this.list = this.list.concat(arr)
          this.loading = false

          if(res.data.totalPages===this.page){ // 到达最大页
            this.finished = true;
          }
          this.page++
        }else {
          this.loading = false;
          this.finished = true;
        }
      }).catch(() => {
        this.isError = true;
      })
    },
    onRefresh(){
      this.finished = true;
      this.page = 1;
      window.setTimeout(()=>{
        this.finished = false;
        this.list = [];
        this.refreshLoading = false;
        window.scrollTo(0, 0);
      },100)
    },
  }
}
</script>

<style lang="less" scoped>

</style>